import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Loads functional usage whenever the scenario context changes.
 */
export const loadForCurrentEntityOnContextChange = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    plugin.collection.feature.actions.changeContext
      .observe()
      .pipe(
        rxjs.map(() =>
          feature.actions.loadForCurrentEntity.request
            .from('(effect) load for current entity on context change')
            .create(),
        ),
      ),
)
